import { IMsalAuthService } from "../msal/msalAuthService";

export interface ISessionService {
    isActive: boolean;
    login(username: string, password: string): angular.IPromise<boolean>;
    logout(status?: string): void;
}

export class SessionService implements ISessionService {

    static $inject = ['$q', '$mdDialog', '$state', '$http', 'LogoutService', 'AuthenticationService', 'MsalAuthService'];
    
    constructor(private _$q: angular.IQService,
        private _$mdDialog: angular.material.IDialogService,
        private _$state: angular.ui.IStateService,
        private _$http: angular.IHttpService,
        private _logoutService: Authentication.LogoutService,
        private _authenticationService: Authentication.AuthenticationService,
        private _msalAuth: IMsalAuthService) {
    }

    get isActive(): boolean {
        return this._msalAuth.msal().getAllAccounts().length > 0;
    }

    login(username: string, password: string): angular.IPromise<boolean> {
        const credential = new Authentication.Credential(username, password);

        const deferred = this._$q.defer<boolean>();
        this._authenticationService.authenticate(credential)
            .then((result) => {
                if (!this.isLoginSuccessful(result))
                    deferred.reject();
            })
            .catch(() => {
                deferred.reject();
            });
        return deferred.promise;
    }

    logout(status = 'inactivity'): void {
        this._msalAuth.msal().logoutRedirect();
    }

    private getLogoutPromise(): angular.IPromise<any> {
        const deferred = this._$q.defer();

        if (this.isActive)
            return this._logoutService.logout()
                .then(() => {
                    deferred.resolve();
                })
                .catch(() => deferred.reject());
        else
            deferred.resolve();

        return deferred.promise;
    }

    private isLoginSuccessful(result: Authentication.Results.IAuthenticationResult): boolean {
        return angular.isObject(result)
            && result.message() === '';
    }

    private getValueFromStorage(key: string): number {
        const storageValue = localStorage.getItem(key);
        const jsonValue = JSON.parse(storageValue);
        const milliseconds = Number(jsonValue);
        return milliseconds / 1000;
    }

    private setValueTimeInStorage(key: string, value: number): void {
        const milliseconds = value * 1000;
        const json = JSON.stringify(milliseconds);
        localStorage.setItem(key, json);
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/sessions/sessionService.ts
 **/